<app-error-page [errorMsg]="errorMsg" *ngIf="containsError"></app-error-page>

<div *ngIf="!containsError">
  <div class="query-servicer-transfers-container">
    <div class="pageHeader" id="submitServicerTransferHeader">Submit Servicer Transfer Query</div>
    <div class="warningMessage" *ngIf="warningMessage"><br><li>{{warningMessage}}</li></div>

    <div class="errorMessage" *ngIf="errorMessage?.length">
      <br>
      You must correct the following error(s) before proceeding:
      <li *ngFor="let message of errorMessage">{{message}}</li>
    </div>

    <form  [formGroup]="queryServicerTransfersForm"  (ngSubmit)= "servicerTransferList()">
      <div class="query-servicer-transfers">
        <div>
          <div class="ui-g">
            <div class="ui-g-3 labelleft glypha-font">Servicer Number Transfer from:</div>
            <div class="ui-g-3" *ngIf="isExternal">
              <fm-select
                [options]="serNumber"
                ariaLabelledBy="default"
                formControlName="servicerNumberFromUI"
              ></fm-select>

            </div>



            <div class="ui-g-3"  *ngIf="!isExternal">
              <input type="text" fmTextInput id="txtInputServicerNumberTransferFrom" minlength="9" maxlength="9"
                     formControlName="servicerNumberFromUI"></div>


            <div class="ui-g-3 labelright glypha-font">to:</div>
            <div class="ui-g-3">
              <input type="text" fmTextInput id="txtInputServicerNumberTransferTo" minlength="9" maxlength="9" formControlName="servicerNumberTo"></div>

          </div>

          <div class="ui-g">
            <div class="ui-g-3 labelleft glypha-font">Effective Date Range from:</div>
            <div class="ui-g-3">
              <fm-calendar id ="dteffectiveDateFrom" dateFormat="mm/dd/yy" placeholder="MM/DD/YYYY" formControlName="effectiveDateFrom"
                [yearNavigator]="true" [monthNavigator]="true" [yearRange]="('1900:2050')" [showClear]="true"></fm-calendar>
            </div>
            <div class="ui-g-3 labelright glypha-font">to:</div>
            <div class="ui-g-3">
              <fm-calendar id ="dteffectiveDateTo" dateFormat="mm/dd/yy" placeholder="MM/DD/YYYY" formControlName="effectiveDateTo"
                [yearNavigator]="true" [monthNavigator]="true" [yearRange]="('1900:2050')" [showClear]="true"></fm-calendar>
            </div>
          </div>

          <div class="ui-g">
            <div class="ui-g-3 labelleft glypha-font">Receipt Date Range from:</div>
            <div class="ui-g-3">
              <fm-calendar id ="dtEffectiveDateReceiptFrom" dateFormat="mm/dd/yy" placeholder="MM/DD/YYYY" formControlName="creationDateFrom"
                [yearNavigator]="true" [monthNavigator]="true" [yearRange]="('1900:2050')" [showClear]="true"></fm-calendar>
            </div>
            <div class="ui-g-3 labelright glypha-font">to:</div>
            <div class="ui-g-3">
              <fm-calendar id ="dtEffectiveDateReceiptTo" dateFormat="mm/dd/yy" placeholder="MM/DD/YYYY" formControlName="creationDateTo"
                [yearNavigator]="true" [monthNavigator]="true" [yearRange]="('1900:2050')" [showClear]="true"></fm-calendar>
            </div>
          </div>

        <div class="ui-g">
          <div class="ui-g-3 labelleft glypha-font">Transaction Status:</div>
          <div class="ui-g-3">
            <div class="select-style">
              <fm-multiselect
                id ="mltslctTransactionStatusList"
                [options]="transactionStatusList"
                ariaLabelledBy="default"
                [filter]="false"
                [displayAll]="false"
                [maxSelectedLabels]="1"
                formControlName="transactionStatusList"
              ></fm-multiselect>
            </div>
          </div>
        </div>


          <div class="ui-g">
            <div class="ui-g-3 labelleft glypha-font"> Sort By:</div>
            <div class="ui-g-3">
              <fm-select
                id ="slctSortBy"
                [options]="sortBy"
                ariaLabelledBy="default"
                formControlName="sortBy"
                placeholder="Choose"
              ></fm-select>
            </div>
            <div class="ui-g-3"></div>
            <div class="ui-g-3"></div>
          </div>

          <div class="ui-g">
            <div class="ui-g-6">
              <button fmButton id="btnSubmit" type="submit" [primary]="true" [small]="true" label="Submit"
                      class="buttonmargin"></button>
              <button fmButton id="btnClear" type="button" label="Clear" [small]="true" (click)="onClear()"
                      class="buttonmargin"></button>
              <button fmButton id="btnCancel" type="button" label="Cancel" [small]="true" routerLink="/reverseMortgage"
                      class="buttonmargin"></button>
            </div>
            <div class="ui-g-6"></div>
          </div>
        </div>
      </div>
    </form>
  </div>
</div>
